import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Button } from "@mui/material";

const LeaveDetail = () => {
  const navigate = useNavigate();

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Leave Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-leaves")}>Leaves</span> -
            Leave Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <div className="profileInfo_head">
          <h2>Leave Details</h2>
        </div>

        <div className="profileInfo_list">
          <ul className="text_info gap_p">
            <li className="w_50">
              <strong>Agent Name</strong>
              <span>Emma Smith</span>
            </li>

            <li className="w_50">
              <strong>{"E-mail"}</strong>
              <span>emma@gmail.com</span>
            </li>

            <li className="w_50">
              <strong> Leave Applied On</strong>
              <span>10 Dec 2024 </span>
            </li>
            <li className="w_50">
              <strong> Leave Type</strong>
              <span>Full Day </span>
            </li>
            <li className="w_50">
              <strong>Leave Start and End Date</strong>
              <span>20-Dec-2025 to 22-Dec-2025</span>
            </li>
            <li className="w_50">
              <strong>No. of days</strong>
              <span>3</span>
            </li>
            <li className="w_50">
              <strong>Approval Status</strong>
              <span>Pending</span>
            </li>
            <li className="w_50" />

            <li className="w_50">
              <strong>Reason</strong>
              <span>
                {" "}
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry
              </span>
            </li>
          </ul>
        </div>
      </div>
    </MainContainer>
  );
};

export default LeaveDetail;
